import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  elementId: string;
  constructor() {
    this.elementId = '';
   }

  scrollToElement() {
    const element = document.getElementById(this.elementId);
    if(element !== null && element !== undefined){
      element.scrollIntoView(true);
    }
    else {
      window.scrollTo(0, 0);
    }
    //this.elementId = '';
  }
}
